import { appLocale } from 'shared';
import { citizenshipConfig } from '../config';
import type { GroupedCountries } from '../types';

const determineAlphabet = (locale: appLocale.config.Locale) => {
  if (locale === appLocale.config.locales.KK) {
    return citizenshipConfig.kazakhAlphabet;
  }
  if (locale === appLocale.config.locales.EN) {
    return citizenshipConfig.englishAlphabet;
  }
  return citizenshipConfig.russianAlphabet;
};

export const groupCountriesByAlphabet = (
  locale: appLocale.config.Locale,
  countryCodes?: string[],
) => {
  const alphabetToUse = determineAlphabet(locale);
  const list = countryCodes
    ? citizenshipConfig.countryList.filter(country =>
        countryCodes.includes(country.code),
      )
    : citizenshipConfig.countryList;

  return alphabetToUse.reduce((groupedCountries, nextLetter) => {
    list.forEach(country => {
      let countryName = country.name;
      if (locale === appLocale.config.locales.KK) {
        countryName = country.nameKK;
      } else if (locale === appLocale.config.locales.EN) {
        countryName = country.nameEN;
      }

      if (countryName.startsWith(nextLetter)) {
        if (groupedCountries[nextLetter]) {
          groupedCountries[nextLetter].push(country);
        } else {
          groupedCountries[nextLetter] = [country];
        }
      }
    });

    return groupedCountries;
  }, {} as GroupedCountries);
};
